import React from 'react'
import './CookieSettingsLink.scss'
import { BuildConfig } from '../config/BuildConfig'

const PrivacyPolicyLinksByCountry: Record<string, string> = {
  au: 'https://www.se.com/au/en/about-us/legal/data-privacy/',
  nz: 'https://www.se.com/nz/en/about-us/legal/data-privacy/',
}

const privacyPolicyHref = PrivacyPolicyLinksByCountry[BuildConfig.brand.countryCode]
  ?? PrivacyPolicyLinksByCountry.au

export const PrivacyPolicyLink = () => (
  <div className="CookieSettingsLink">
    <a
      className="proxyLink"
      href={privacyPolicyHref}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy policy
    </a>
  </div>
)
